import React from 'react';
import { AlertCircle } from 'lucide-react';

const ErrorState = ({ message = 'Bir hata oluştu', onRetry }) => {
  return (
    <div className="flex flex-col items-center justify-center py-12" data-testid="error-state">
      <AlertCircle className="w-16 h-16 text-red-500 mb-4" />
      <h3 className="text-xl font-bold text-gray-900 mb-2">Üzgünüz!</h3>
      <p className="text-gray-600 mb-4">{message}</p>
      {onRetry && (
        <button
          onClick={onRetry}
          className="bg-junto-red text-white px-6 py-2 rounded-lg hover:bg-junto-red-dark transition"
        >
          Tekrar Dene
        </button>
      )}
    </div>
  );
};

export default ErrorState;